import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { getScreenName, getUserIsLoggedIn  } from '../../../Utils/helper';
import {
  navigateToLoginPage,
  navigateToOrderlistPage,
} from '../../../Utils/redirections';
import Loader from '../../Loader';
import LoginPopup from '../../LoginModule';
import { showNewLogin } from '../../LoginModule/NewLoginModule/common';
import SocialImages from '../../ProductNew/NewFooter/SocialIcons/SocialImages';
import ShopByCategory from './ShopByCategory';
import NewCategory from './NewCategory';
import { getWebUserType } from '../../../Utils/getWebUserType';
import {
  CopyRightMylo,
  ExtraHeight,
  L0BottomSpan,
  Overlay,
  SideDrawerContainer,
  SideScroll,
  SocialImagesContainer,
} from './styled';
import { addOneSubCategory } from './utils';
import TrackOrder from './TrackOrder';
import NeedHelp from './NeedHelp';
import GetMyloAppBanner from './GetMyloAppBanner';
import { fireEvent } from '../../../Utils/fireEvent';

export default function SideDrawer(props) {
  let {
    setDrawerOpen,
    categoryData,
    setShowLoginPopup,
    hideLogin,
    setCartItems,
    drawerOpen,
    // languageRedirectionLinks,
  } = props;
  // const updatedCategoryData = addOneSubCategory(
  //     JSON.parse(JSON.stringify(categoryData)),
  // );
  const router = useRouter();
  // if (categoryData?.length > 1) {
  //     categoryData[1].deeplink = "/category/mylo-care-7545";
  //     categoryData[2].deeplink = "/category/mylo-baby-7546";
  // }
  const [drawersCategories, setDrawerCategory] = useState(
    JSON.parse(JSON.stringify(categoryData)),
  );
  const [showLoader, setShowLoader] = useState(false);
  const trackOrderHandler = (e) => {
    e.stopPropagation();
    setShowLoader(true);
    sideDrawerClickEvent('Track Order');

    setTimeout(() => {
      if (!getUserIsLoggedIn()) {
        if (showNewLogin()) {
          localStorage.setItem('redirectRoute', window.location.pathname);
          navigateToLoginPage(false, false, true);
        } else setShowLoginPopup(true);
      } else {
        // redirectToMyloUrl("/store/orderlist");
        navigateToOrderlistPage();
      }
      setShowLoader(false);
    }, [200]);
    // setDrawerOpen(false);
  };

  const sideDrawerClickEvent = (itemName) => {
    fireEvent({
      category: 'clicked_sidedrawer_item',
      screen_name: getScreenName(),
      // section: categoryData[indexData]?.tabName,
      parent: 'NA',
      card_name: itemName,
    });
  };
  const restoreSideBarValue = sessionStorage.getItem('sideBarOrder');
  const initialOrder = restoreSideBarValue?.split(',') || [1, -1, -1, -1];

  useEffect(() => {
    const updatedCategoryData = addOneSubCategory(
      JSON.parse(JSON.stringify(categoryData)),
    );
    setDrawerCategory(updatedCategoryData);
  }, [categoryData]);
  useEffect(() => {
    if (restoreSideBarValue) {
      document.getElementById(restoreSideBarValue)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
    return () => {
      document.body.classList.remove('noScroll');
    };
  }, []);
  useEffect(() => {
    if (drawerOpen) {
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    } else {
      document.getElementsByTagName('body')[0].classList.remove('noScroll');
    }
  }, [drawerOpen]);
  const closeSideDrawer = () => {
    setDrawerOpen(false);
  };
  const needHelpClickHandler = (e) => {
    e.stopPropagation();
    setShowLoader(true);
    sideDrawerClickEvent('My Refunds');
    setTimeout(() => {
      if (!getUserIsLoggedIn()) {
        localStorage.setItem('redirectRoute', window.location.pathname);
        navigateToLoginPage(false, false, false, true);
      } else {
        router.push(`/need-help` + window.location.search);
      }
      setShowLoader(false);
    }, [200]);
  };
  return (
    <Overlay onClick={() => setDrawerOpen(false)} drawerOpen={drawerOpen}>
      <SideDrawerContainer onClick={(e) => e.stopPropagation()}>
        {/* <WaveLogoBox>
                    <WaveLogo src={images.PdpHeaderLogo} alt="" />
                </WaveLogoBox> */}

        <SideScroll>
          {!hideLogin && (
            <LoginPopup
              trackOrderHandler={trackOrderHandler}
              setCartItems={setCartItems}
            />
          )}
          {/* {getUserIsLoggedIn() ? <GetMyloAppBanner /> : null} */}
           <GetMyloAppBanner />

          <TrackOrder trackOrderHandler={trackOrderHandler} />
          <NeedHelp needHelpClickHandler={needHelpClickHandler} />
          {/* <HomeButton /> */}
          <L0BottomSpan showMargin={true} />
           {getWebUserType() === 'B' ? (
          <ShopByCategory
            categoryData={drawersCategories}
            setDrawerOpen={setDrawerOpen}
            initialOrder={initialOrder}
            restoreSideBarValue={restoreSideBarValue}
            trackOrderHandler={trackOrderHandler}
          />
            ) : (
          <NewCategory
            categoryData={drawersCategories}
            setDrawerOpen={setDrawerOpen}
             initialOrder={initialOrder}
            restoreSideBarValue={restoreSideBarValue}
            trackOrderHandler={trackOrderHandler}
          />
           )}

          {/* <LearnButton closeSideDrawer={closeSideDrawer} /> */}

          {/* <TrackOrder trackOrderHandler={trackOrderHandler} /> */}
          {/* <DownloadAppButton setShowLoader={setShowLoader} /> */}
          {/* <div>
                        <Collapsible
                            trigger={
                                <SideDrawerHelpButton>
                                    Contact Us
                                </SideDrawerHelpButton>
                            }
                            transitionTime={200}
                            open={false}
                        >
                            <WhatsappHelp
                                sideDrawerClick={sideDrawerClickEvent}
                            />

                            <ContactUsSub
                                text={"Email"}
                                clickHandler={chatHandler}
                            />
                            <ContactUsSub
                                text={"Call"}
                                clickHandler={() =>
                                    callHandler("", "tel:0804-719-0745")
                                }
                            />
                        </Collapsible>
                    </div> */}

          <SocialImagesContainer>
            <SocialImages />
            <CopyRightMylo>2025 Mylo</CopyRightMylo>
          </SocialImagesContainer>
          <ExtraHeight></ExtraHeight>
        </SideScroll>
        {showLoader && <Loader />}
      </SideDrawerContainer>
    </Overlay>
  );
}
